/* ============================================================
   TFS v41 - CORRECTIFS, QUATRIEME SERIE
   Charge en DERNIER, apres tfs-v41-fixes.js.
   ============================================================ */
(function () {
  'use strict';

  /* 9. CHOISIR UNE TAILLE FAISAIT DESCENDRE LA PAGE TROP BAS

     Signale par le fondateur : « quand on choisit une taille, ca nous
     fait descendre sur la page, et on descend trop bas, on rate le
     bouton Precommander ».

     Trois scripts differents deplacent la page au meme moment :
       - theme.js, updateVariant() : scrollIntoView(block: 'nearest')
         sur la photo de la variante, de facon synchrone.
       - tfs-v23-variant-focus.js : scrollIntoView(block: 'center')
         sur la meme photo, 60 ms plus tard. C'est celui-ci le
         coupable principal : 'center' recentre la GALERIE au milieu
         de la fenetre, ce qui pousse mecaniquement la colonne d'achat
         - et donc le bouton - hors de l'ecran.
       - le correctif v41 precedent ne neutralisait que le premier :
         sa fenetre de garde faisait 40 ms, celui de v23 arrive a 60.

     On elargit la fenetre a 400 ms, mais on ne neutralise PLUS tout :
     le geste TAILLE reste entierement bloque - et ne perd rien, les
     quatre tailles d'une couleur partageant le meme featured_media_id,
     il n'y a jamais de photo a aller chercher. Le geste COULEUR, lui,
     retrouve le droit d'amener sa photo, uniquement sur la mise en
     page bureau (>= 991 px) et au plus pres. Sans ca, la pastille
     couleur choisie ne menait a rien sur ordinateur : la photo portait
     bien le liseré .is-active-variant, trois ecrans plus bas, la ou
     personne ne pouvait la voir. Les seuils sont expliques un a un
     dans la fonction.
     Le defilement HORIZONTAL de la galerie sur telephone n'est pas
     concerne : v23 le fait avec gallery.scrollTo, pas avec
     scrollIntoView.

     Ce fichier NE remplace PAS la garde de tfs-v41-fixes.js : charge
     apres, il l'ENVELOPPE. Les deux gardes sont vivantes - celle-ci
     (400 ms) par-dessus celle de fixes.js (40 ms), elle-meme par-dessus
     le correctif prefers-reduced-motion de tfs-premium.js. Ne pas
     supposer qu'editer ce seul fichier suffit a tout debloquer.
  */
  function suppressOptionScroll() {
    if (!document.querySelector('[data-product-root]')) return;

    var guardUntil = 0;   /* fenêtre pendant laquelle la galerie est neutralisée */
    var colourFrom = 0;   /* ...sauf le geste COULEUR, à partir de cet instant   */
    var DESKTOP = '(min-width: 991px)';  /* = la bascule 2 colonnes de base.css  */

    function arm(e) {
      var group = e.target && e.target.closest
        ? e.target.closest('[data-option-index]')
        : null;
      if (!group) return;
      var now = Date.now();
      guardUntil = now + 400;
      /* main-product.liquid pose .product-option--size sur le fieldset dont le
         nom d'option contient taille / size / pointure. Tout le reste est une
         couleur : c'est le seul geste qui doit encore amener sa photo. */
      colourFrom = group.classList.contains('product-option--size') ? 0 : now + 30;
    }

    document.addEventListener('change', arm, true);
    document.addEventListener('click', arm, true);

    var native = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function () {
      if (Date.now() >= guardUntil) return native.apply(this, arguments);
      if (!this.closest || !this.closest('.product-gallery')) return native.apply(this, arguments);

      /* Couleur, et seulement sur la mise en page bureau (galerie en deux
         colonnes, dans le flux de la page) : on laisse venir la photo, au
         plus près. 'nearest' ne bouge pas si elle est déjà visible et ne
         recentre JAMAIS la galerie — c'est le 'center' de tfs-v23 qui
         poussait le bouton hors de l'écran.
         Le seuil de 30 ms laisse passer l'appel de tfs-v23 (60 ms) et
         retient celui de theme.js (0 ms, synchrone) : une seule photo
         bouge, pas deux qui se disputent le défilement. */
      if (colourFrom && Date.now() >= colourFrom
          && window.matchMedia(DESKTOP).matches) {
        return native.call(this, { behavior: 'smooth', block: 'nearest' });
      }
      return;
    };
  }

  /* 10. FILET SUR LA BARRE D'ACHAT COLLANTE

     theme.js n'affiche la barre collante que lorsque le bouton
     principal sort de l'ecran, via un IntersectionObserver a seuil
     0,12. Si le bouton n'a jamais ete visible - ce qui arrive quand
     on arrive sur la fiche depuis une ancre, ou apres un changement
     de variante qui a modifie la hauteur de la colonne - l'observateur
     peut ne jamais basculer. On force une reevaluation apres chaque
     choix d'option pour que la barre soit toujours coherente avec ce
     que le client voit.
  */
  function refreshStickyBar() {
    var bar = document.querySelector('[data-product-sticky]');
    var btn = document.querySelector('[data-add-to-cart]');
    if (!bar || !btn) return;

    function evaluate() {
      var r = btn.getBoundingClientRect();
      var visible = r.top < window.innerHeight && r.bottom > 0;
      bar.classList.toggle('is-visible', !visible);
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-option-index]')) {
        window.setTimeout(evaluate, 450);
      }
    }, true);
  }

  function boot() {
    try { suppressOptionScroll(); } catch (e) {}
    try { refreshStickyBar(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.setTimeout(boot, 10); });
  } else {
    window.setTimeout(boot, 10);
  }
})();
